import { Card, CardProps } from "@mui/material"
import React, { PropsWithChildren } from "react"

interface HFCardProps extends CardProps {
  headerText: string;
}

const HFCard: React.FC<PropsWithChildren<HFCardProps>> = ({
  children,
  headerText
}) => {
  return (
    <div className='m-b-16'>
      <Card variant="outlined">
        <div className="box-header flex flex-space-between flex-align-center">
          {headerText}
        </div>
        {children}
      </Card>
    </div>
  )
}

export default HFCard;